export const getSlug = (pathname: string) => {
  if (pathname.slice(-1) === '/') {
    return pathname.slice(0, -1).split('/').pop() ?? ''
  } else {
    return pathname.split('/').pop() ?? ''
  }
}

export const getBlogPath = (uri?: string) => {
  return `${process.env.REACT_APP_PRISMIC_BLOG_PATH}${uri ? `/${uri}` : ''}`
}

export const getPrismicPreviewPath = () => {
  return '/prismic-preview'
}
